import axios from 'axios'
const TEST_URL = 'http://localhost:8080'
const TEST_ENV_URL = "https://attendance.hopedrew.co.uk";
const LIVE_URL = "https://attendance.luddononsite.co.uk/"
export default axios.create({
    baseURL: LIVE_URL,
    headers:{
        'Content-Type': 'application/json'
    }
});

